import districtsData from '../data/districts.json';

export const getDistrictTranslation = (districtName, currentLanguage) => {
  if (!districtName) return districtName;

  const languageMap = {
    'ar': 'ar',
    'fr': 'fr',
    'en': 'en'
  };

  const targetLanguage = languageMap[currentLanguage] || 'ar';
  const translationKey = districtName.trim();

  const newTranslations = JSON.parse(localStorage.getItem('districtTranslations') || '{}');

  if (newTranslations[translationKey]) {
    return newTranslations[translationKey][targetLanguage] || districtName;
  }

  const staticTranslation = districtsData.districts[translationKey];
  if (staticTranslation) {
    return staticTranslation[targetLanguage] || districtName;
  }

  return districtName;
};

export const addDistrictTranslation = (districtName, translations) => {
  const newTranslations = JSON.parse(localStorage.getItem('districtTranslations') || '{}');
  const translationKey = districtName.trim();

  newTranslations[translationKey] = {
    ar: translations.ar || districtName,
    fr: translations.fr || districtName,
    en: translations.en || districtName
  };

  localStorage.setItem('districtTranslations', JSON.stringify(newTranslations));

  const combinedData = { ...districtsData.districts, ...newTranslations };
  const jsonString = JSON.stringify({ districts: combinedData }, null, 2);

  const blob = new Blob([jsonString], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = 'districts.json';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);

  return { success: true, message: 'District translations saved to localStorage and exported.' };
};

export const reloadTranslations = () => {
  // This function would typically re-fetch or re-load the static data if it were dynamic.
  // For now, it just returns the current static data.
  return districtsData;
};

export const validateTranslationsFile = (file) => {
  // Placeholder for actual file validation logic
  return { success: true, message: 'File validated successfully.' };
};

export const saveTranslationsToFile = () => {
  const newTranslations = JSON.parse(localStorage.getItem('districtTranslations') || '{}');
  const combinedData = { ...districtsData.districts, ...newTranslations };
  const jsonString = JSON.stringify({ districts: combinedData }, null, 2);

  const blob = new Blob([jsonString], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = 'districts.json';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);

  return { success: true, message: 'District translations exported to districts.json.' };
};
